import { composeDirective } from './helpers';

const NAME = 'focus-outside';
const LISTENERS = ['focusin'];

function validator(el, e) {
  return el !== e.target && !el.contains(e.target);
}

export default composeDirective(NAME, LISTENERS, validator);
